import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/api/front/login",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    url: "/api/front/user/register",
    method: "post",
    data,
  });
}

export function getCaptcha(data) {
  return request({
    url: "/api/common/captcha",
    method: "post",
    data,
  });
}

export function getUserInfo(data) {
  return request({
    url: "/api/front/user/live?type=info",
    method: "get",
    params: data,
  });
}

export function profileEdit(data) {
  return request({
    url: "/api/front/user/infos?type=update",
    method: "post",
    data,
  });
}

export function profileEdit2(data) {
  return request({
    url: "/api/front/user/updateTwo",
    method: "post",
    data,
  });
}

export function wechatLoginToken(data) {
  return request({
    url: "/wx_oauth/wechat_login_token",
    method: "get",
    params: data,
  });
}

export function scanSubscribeQrcode(data = {}) {
  return request({
    url: "/api/weixin/get?type=scanSubscribeQrcode",
    method: "get",
    params: data
  })
}

export function scanSubscribeQrcodeResults(data = {}) {
  return request({
    url: "/api/weixin/get?type=scanSubscribeQrcodeResults",
    method: "get",
    params: data
  })
}

// 反馈
export function feedback(content) {
  return request({
    url: `/api/front/user/infos?type=feedback`,
    method: "post",
    data: {
      content
    }
  });
}